<template>
	<form class="c-form-script-generator" @submit.prevent="onSubmit">
		<Form
			:processing="processing"
			ref="form"
			:schema="schema"
			v-model="form"
			buttonText="Next"
			@status="saveStatus"
			:errors="errors"
		></Form>
	</form>
</template>

<script>
import Form from './index.vue';

const schema = {
	duration: {
		component: 'InputRadioGroup',
		label: 'Video duration',
		options: [
			{
				key: '5-15 seconds',
				value: '5-15 seconds',
			},
			{
				key: '15-30 seconds',
				value: '15-30 seconds',
			},
			{
				key: '30-60 seconds',
				value: '30-60 seconds',
			},
			{
				key: '60-120 seconds',
				value: '60-120 seconds',
			},
			{
				key: '120-300 seconds',
				value: '120-300 seconds',
			},
			{
				key: '> 300 seconds(5 minutes)',
				value: '> 300 seconds(5 minutes)',
			},
		],
		validations: {
			required: {
				params: null,
				message: 'This field is required',
			},
		},
	},
};
export default {
	components: {
		Form,
	},

	data: function () {
		return {
			schema: schema,
			processing: false,
			form: {},
			errors: [],
			status: null,
		};
	},

	methods: {
		saveStatus: function (saveStatus) {
			this.status = saveStatus;
		},
		async onSubmit() {
			this.$refs.form.validate();

			if (this.status.invalid) {
				return;
			}

			let form = this.form;

			this.processing = true;

			this.processing = false;

			this.$emit('onSubmit', form);
		},
	},
};
</script>

<style lang="scss">
.c-form-video-script {
}
</style>
